var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearchLoupe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M15.905 7.956c.001-1.8-.608-3.547-1.73-4.955C13.056 1.592 11.49.606 9.736.202 7.98-.2 6.14.002 4.515.78c-1.623.778-2.935 2.083-3.72 3.703C.01 6.103-.201 7.941.194 9.697c.396 1.756 1.376 3.325 2.78 4.452 1.404 1.127 3.15 1.744 4.95 1.75 1.8.007 3.55-.598 4.962-1.715L17.703 19 19 17.704l-4.817-4.816c1.116-1.402 1.723-3.14 1.722-4.932zm-7.953 6.115c-1.21 0-2.392-.358-3.398-1.03-1.006-.672-1.79-1.627-2.253-2.745-.463-1.117-.584-2.347-.348-3.533s.818-2.276 1.674-3.13c.855-.856 1.945-1.438 3.132-1.674s2.417-.115 3.534.348c1.118.462 2.073 1.246 2.746 2.252.672 1.005 1.03 2.188 1.03 3.397 0 1.622-.644 3.177-1.791 4.324-1.147 1.147-2.703 1.791-4.326 1.791z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchLoupe);
export default __webpack_public_path__ + "static/media/icon-search-loupe.aa4a868d.svg";
export { ForwardRef as ReactComponent };